import { useState } from 'react';
import DOMPurify from "dompurify";

import classes from './AddToCart.module.css';

import Addons from "../product/Addons";
import StockNotification from "./StockNotification";

function AddToCart(props) {
	const [isLoading, setIsLoading] = useState(false);
	const [quantity, setQuantity] = useState(1);
	const [showAddons, setShowAddons] = useState(false);
	const [buttonIsActive, setButtonIsActive] = useState(true);
	const [cartProductId, setcartProductId] = useState(0);

	function updateQuantity(newQuantity) {
		if(newQuantity > 0) {
			setQuantity(Number(newQuantity));
		}
	}

	function closeAddons() {
		setShowAddons(false);
	}

	function addToCart(id) {
		setIsLoading(true);
		const productData = {};
		productData.quantity = quantity;
		productData.id = id;

		fetch(
			'/cart/m_addToCart',
			{
				method: 'POST',
				body: JSON.stringify(productData),
				headers: {
					'Content-Type': 'application/json',
					'HTTP_X_REQUESTED_WITH': 'xmlhttprequest'
				}
			}
		).then(response => {
			return response.json();
		}).then(data => {
			var element = document.getElementById("new_product_added");
			var cart_html = '<div id="cart_preview"><div id="close_preview"><span class="glyphicon glyphicon-remove-circle"></span></div><div id="cart_button"><a class="btn btn-warning hidden-xs" href="/cart"><span class="glyphicon glyphicon-shopping-cart"></span> Check out your cart</a><a class="btn btn-warning visible-xs" href="/cart"><span class="glyphicon glyphicon-shopping-cart"></span> Check out your cart</a></div><div id="products_preview">';
			var i = 0;
			while(data.products[i] !== undefined) {
				if(i === 0) {
					cart_html += '<div class="new product">';
				} else {
					cart_html += '<div class="product">';
				}
				if(data.products[i].id === id) {
					setcartProductId(data.products[i].cart_product_id);
				}
				cart_html += '<a href="/product/' + data.products[i].slug + '"><div><img src="https://poolsupplies.nyc3.cdn.digitaloceanspaces.com/media/' + data.products[i].md_filename + '"/></div><div>' + data.products[i].quantity + 'x ' + data.products[i].name + '</div></a></div>';
				i++;
			}
			element.innerHTML = cart_html;
			element.classList.add("showCart");
			setIsLoading(false);
			setTimeout(() => {
				setShowAddons(true);
			}, 600);
			if(props.disableAfterAdd) {
				setButtonIsActive(!buttonIsActive);
			}
		});
	}

	function removeFromCart(id) {
		const productData = {};
		productData.cart_product_id = id;

		fetch(
			'/cart/m_removeProduct',
			{
				method: 'POST',
				body: JSON.stringify(productData),
				headers: {
					'Content-Type': 'application/json',
					'HTTP_X_REQUESTED_WITH': 'xmlhttprequest'
				}
			}
		).then(response => {
			return response.json();
		}).then(data => {
			var element = document.getElementById("new_product_added");
			var cart_html = '<div id="cart_preview"><div id="close_preview"><span class="glyphicon glyphicon-remove-circle"></span></div><div id="cart_button"><a class="btn btn-warning hidden-xs" href="/cart"><span class="glyphicon glyphicon-shopping-cart"></span> Check out your cart</a><a class="btn btn-warning visible-xs" href="/cart"><span class="glyphicon glyphicon-shopping-cart"></span> Check out your cart</a></div><div id="products_preview">';
			var i = 0;
			while(data.products[i] !== undefined) {
				if(i === 0) {
					cart_html += '<div class="new product">';
				} else {
					cart_html += '<div class="product">';
				}
				cart_html += '<a href="/product/' + data.products[i].slug + '"><div><img src="https://poolsupplies.nyc3.cdn.digitaloceanspaces.com/media/' + data.products[i].md_filename + '"/></div><div>' + data.products[i].quantity + 'x ' + data.products[i].name + '</div></a></div>';
				i++;
			}
			element.innerHTML = cart_html;
			element.classList.add("showCart");
			if(props.disableAfterAdd) {
				setButtonIsActive(!buttonIsActive);
			}
		});
	}


	if(isLoading) {
		return (
			<div className={"form-inline mobile-center"}>
				<div className={"row"}>
					<div className={`${props.showQuantity ? "col-xs-3 col-sm-6 col-md-5 col-lg-3" : classes.hidden}`}>
						<div className={"quantity-selector"}>
							<span className={"quantity-label"}></span>
							<button className={"quantity-btn decrement"} type={"button"} onClick={() => updateQuantity(quantity-1)}>&mdash;</button>
							<input type={`${props.showQuantity ? "text" : "hidden"}`} className={"form-control product-qty"} id={props.product.id + "_qty"} min="1" name="quantity" value={quantity} onChange={(e) => updateQuantity(e.target.value)}/>
							<button className={"quantity-btn increment"} type={"button"} onClick={() => updateQuantity(quantity+1)}>+</button>
						</div>
					</div>
					<div className={"col-xs-9 col-sm-6 col-md-7 col-lg-9"}>
						<input type={"hidden"} id={"product_id"} name="product_id" value={props.product.id}/>
						<button>Adding...</button>
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className={"form-inline mobile-center"}>
			<div className={"row"}>
				{ ((props.product.inStock || props.product.preorderable) && props.product.isTemporarilyUnavailable !== 1) && <div className={`${props.showQuantity ? "col-xs-3 col-sm-6 col-md-5 col-lg-3" : classes.hidden}`}>
					<div className={"quantity-selector"}>
						<span className={"quantity-label"}></span>
						<button className={"quantity-btn decrement"} type={"button"} onClick={() => updateQuantity(quantity-1)}>&mdash;</button>
						<input type={`${props.showQuantity ? "text" : "hidden"}`} className={"form-control product-qty"} id={props.product.id + "_qty"} min="1" name="quantity" value={quantity} onChange={(e) => updateQuantity(e.target.value)}/>
						<button className={"quantity-btn increment"} type={"button"} onClick={() => updateQuantity(quantity+1)}>+</button>
					</div>
				</div> }
				<div className={`${props.showQuantity ? "col-xs-9 col-sm-6 col-md-7 col-lg-9" : classes.noQuantity + " col-xs-12"}`}>
					<input type={"hidden"} id={"product_id"} name="product_id" value={props.product.id}/>					

					{ (props.product.inStock && (props.step === 1 || props.step > props.totalSteps) && buttonIsActive) && <button id={props.product.id + "_btn"} type="submit" className={classes.cartAdd + " btn btn-prod btn-lg btn-success"} onClick={() => addToCart(props.product.id)}><span className={"glyphicon glyphicon-shopping-cart"}></span>Add To Cart</button> }
					{ (props.product.inStock && (props.step === 1 || props.step > props.totalSteps) && !buttonIsActive) && <button id={props.product.id + "_btn"} type="submit" className={classes.cartAdd + " btn btn-prod btn-lg btn-preorder"} onClick={() => removeFromCart(cartProductId)}><span className={"glyphicon glyphicon-shopping-cart"}></span><i>Remove Item</i></button> }

					{ (!props.product.inStock && props.product.preorderable) && <button id={props.product.id + "_btn"} type="submit" className={classes.cartAdd + "btn btn-prod btn-lg btn-preorder"} onClick={() => addToCart(props.product.id)}><span className={"glyphicon glyphicon-shopping-cart"}></span>Pre-order</button> }

					{ ((!props.product.inStock && !props.product.preorderable) || props.product.isTemporarilyUnavailable === 1) && 	
						<StockNotification product={props.product}/>
					}

				</div>
			</div>
			<div className={"row"}>
				{(typeof props.product.pricing.Quantity !== 'undefined') && 
				<div class="well well-sm">
					<h3>Quantity Discount!</h3>
					<p>If you buy <strong>{props.product.pricing.Quantity.minQty} or more</strong> (up to <span>{props.product.pricing.Quantity.maxQty}</span>), the price will be <strong><span class="text-danger">$<b>{props.product.pricing.Quantity.price}</b></span> each</strong>.</p>
				</div>
				}
			</div>
			<div className={"row"}>
				{ (props.product.inStock && props.product.quantityAvailable === 0 && props.product.dropshipMessage !== null) && 
					<div className={"well green-border dropship-message"}>
						<h5 dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.product.dropshipMessage) }}></h5>
					</div> }
			</div>
			<div className={"hidden-xs"}>
			{((typeof props.addons !== 'undefined') && props.addons.length > 0 && showAddons) &&
				<Addons product={props.product} addons={props.addons} showQuantity={false} closeAddons={closeAddons}/>
			}
			</div>
		</div>
	);
}

export default AddToCart;